import { FormControlLabel, Switch, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TTSCustomEditorColors } from "shared/constants";
import getSwitchStyles from "styles/switch-styles";

interface SSMLToggleSwitchProps {
  isHtmlView: boolean;
  handleToggleHtmlView: () => void;
  disabled?: boolean;
}

export default function SSMLToggleSwitch({
  isHtmlView,
  handleToggleHtmlView,
  disabled = false,
}: SSMLToggleSwitchProps): JSX.Element {
  const { thumbStyle, trackStyle } = getSwitchStyles(isHtmlView);
  const { t } = useTranslation();

  return (
    <FormControlLabel
      sx={{
        margin: "0 !important",
      }}
      checked={isHtmlView}
      onChange={handleToggleHtmlView}
      disabled={disabled}
      control={
        <Switch
          sx={{
            marginTop: "4px",
            marginLeft: "4px",
            width: "auto",
            "& .MuiSwitch-thumb": thumbStyle,
            "& .MuiSwitch-track": trackStyle,
          }}
        />
      }
      label={
        <Typography
          variant="body2"
          sx={{
            color: disabled
              ? TTSCustomEditorColors.IconDisabledColor
              : TTSCustomEditorColors.ToolbarIconColor,
          }}
        >
          {t("tts.toolbarMenu.showSSMLTags")}
        </Typography>
      }
      labelPlacement="end"
      id="ssml-toggle-switch"
    />
  );
}
